import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

// Site-styled Cm3 badge (gold frame, obsidian core). `lg` for hero use, default for inline strips.
export const Cm3Badge = ({ id = "87225", size = "md", to = "/compliance", className = "" }) => {
  const lg = size === "lg";
  return (
    <Link
      to={to}
      data-testid="cm3-badge"
      aria-label={`Cm3 prequalified contractor, Cm3 ID ${id}`}
      className={`group inline-flex items-center gap-3 rounded-sm border border-gold/60 bg-obsidian-800 pr-4 shadow-gold/20 hover:border-gold hover:shadow-gold transition-all ${lg ? "py-3 pl-3" : "py-2 pl-2"} ${className}`}
    >
      <span className={`flex items-center justify-center rounded-sm bg-gold text-obsidian ${lg ? "h-12 w-12" : "h-9 w-9"}`}>
        <ShieldCheck size={lg ? 26 : 20} strokeWidth={2.4} />
      </span>
      <span className="leading-none">
        <span className={`block font-heading font-black tracking-tight text-white ${lg ? "text-lg" : "text-sm"}`}>
          Cm3 <span className="gold-text">PREQUALIFIED</span>
        </span>
        <span className={`mt-1 block whitespace-nowrap font-mono uppercase tracking-[0.18em] sm:tracking-[0.25em] text-zinc-400 ${lg ? "text-[10px] sm:text-[11px]" : "text-[9px]"}`}>
          Cm3 ID {id} · WHS Verified
        </span>
      </span>
    </Link>
  );
};
